import { type StatsigExperimentName, useExperiment } from '@coursera-web/statsig';

const REVOKE_ACCESS_EXPERIMENT_NAME: StatsigExperimentName = 'revoke-access-after-free-trial-cancellation';
const REVOKE_ACCESS_GROUP_NAME = 'revoke-access';

const LIMITED_FREE_TRIAL_EXPERIMENT_NAME: StatsigExperimentName = 'limited-free-trial';
const LIMITED_FREE_TRIAL_GROUP_NAME = 'limited-free-trial';

// https://console.statsig.com/2aQACzHI81tdbY41wEZm3H/experiments/revoke-access-after-free-trial-cancellation/setup
export const useIsRevokeAccessEnabled = (): boolean => {
  const experiment = useExperiment(REVOKE_ACCESS_EXPERIMENT_NAME);
  return experiment.groupName === REVOKE_ACCESS_GROUP_NAME;
};

// https://console.statsig.com/2aQACzHI81tdbY41wEZm3H/experiments/limited-free-trial/setup
export const useIsLimitedFreeTrialEnabled = (): boolean => {
  const experiment = useExperiment(LIMITED_FREE_TRIAL_EXPERIMENT_NAME);
  return experiment.groupName === LIMITED_FREE_TRIAL_GROUP_NAME;
};
